import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const FindMyAddressStyle = styled.div`
  .find-address-wrapper {
    position: relative;
    display: block;
    width: 100%;
    margin-bottom: ${theme.grid.spacing.xs}px;
    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      max-width: 400px;
      display: flex;
    }
    .find-address-input {
      width: 192px;

      .input-wrapper {
        width: 100%;
      }
      input {
        width: 192px;
      }
    }
    button.find-address-button {
      position: relative;
      height: 40px;
      margin-top: ${theme.grid.spacing.base}px;
      margin-bottom: ${theme.grid.spacing.base}px;
      @media (min-width: ${theme.grid.resolution.tablet.width}px) {
        margin-left: ${theme.grid.spacing.base}px;
        top: 8px;
        margin-top: 0;
        margin-bottom: 0;
      }
    }
  }
  .address-selector-wrapper {
    margin-bottom: ${theme.grid.spacing.xs}px;
  }

  button.cancel-postcode {
    top: 1px;
    left: 8px;
  }
  .manual-link {
    position: relative;
    left: 3px;
    margin-top: ${theme.grid.spacing.xs}px;
    margin-bottom: ${theme.grid.spacing.base}px;
  }

  .where-to-title {
    margin-top: ${theme.grid.spacing.base}px;
    margin-bottom: ${theme.grid.spacing.xs}px;
  }

  @media (max-width: ${theme.grid.resolution.tablet.width}px) {
    .tool-tip-desktop {
      display: none;
    }
    .input-info-wrapper {
      display: flex;
    }
    .tool-tip-mobile {
      margin-left: ${theme.grid.spacing.s}px;
      top: 18px;
    }
  }
  @media (min-width: ${theme.grid.resolution.tablet.width}px) {
    .tool-tip-mobile {
      display: none;
    }
    .tool-tip-desktop {
      margin-left: ${theme.grid.spacing.s}px;
      top: 18px;
    }
  }
`
